<style lang="scss" scoped>
.finances {
  &__statement {
  @screen mobile {
    @apply justify-between;
    &-tit {
      @apply flex-none pt-2 #{!important};
    }
    &-val {
      @apply flex-none  mb-0 #{!important};
    }
  }
  }
}
</style>

<template>
  <section class="finances__widget">
    <article class="finances__widget-body">
      <h3 class="finances__widget-title">
        Saldo atual
        ({{ $moment().format('MMMM/YYYY') }})

        <i v-if="loading" class="icon loading float-right" />
      </h3>

      <transition name="fade">
        <dl class="finances__statement" v-if="!loading">
          <template v-for="field in balance">
            <dt
              v-if="field.label"
              :key="field.label+'label'"
              class="finances__statement-tit"
            >
              {{ field.label }}
            </dt>

            <dd
              v-if="field.label"
              :key="field.label+'value'"
              :class="(field.value !== 0) &&
                (field.label === 'Gastos do mês')
                  ? 'finances__statement-val--outcome'
                  : 'finances__statement-val--income'
              "
              class="finances__statement-val"
            >
              R$ {{ field.value | TO_BRL }}
            </dd>
          </template>
        </dl>
      </transition>
    </article>

    <footer class="finances__widget-footer">
      <button
        class="btn btn-primary"
        :disabled="!Array.isArray(financialCategories) || financialCategories.length === 0"
        @click="newFinancialStatement()"
      >
        Adicionar lançamento
      </button>
    </footer>
  </section>
</template>

<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'currentBalance',

  props: {
    financialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      loading: false,
      balance: {
        drconectaRevenue: {
          label: 'Consultas Dr.Conecta',
          value: null
        },
        particularRevenue: {
          label: 'Consultas particulares',
          value: null
        },
        otherRevenue: {
          label: 'Outras receitas',
          value: null
        },
        expense: {
          label: 'Gastos do mês',
          value: null
        },
        total: {
          label: 'Saldo do mês',
          value: null
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  },

  watch: {
    office: {
      deep: true,
      immediate: false,
      handler () {
        this.init()
      }
    }
  },

  created () {
    EventBus.$on('reload-finance', () => this.init())
    this.init()
  },

  methods: {
    init () {
      const month = this.$moment().format('MM')
      const year = this.$moment().format('YYYY')
      const prefix = this.fn_GET_PARENT_ROUTE(this.$route)
      const suffix = `?month=${month}&year=${year}&filterNot[fs.status]=CANCELADO`
      const url = `/${prefix}/doctor_office/${this.office.id}/financial_statement/dashboard_balance${suffix}`

      this.loading = true
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          for (let field in this.balance) {
            this.balance[field].value = res.data[field] || null
          }
        })
        .catch(err => console.log('err', err))
        .finally(() => (this.loading = false))
    },

    newFinancialStatement () {
      EventBus.$emit('new-financial-statement', { ...this.office })
    }
  }
}
</script>
